// Defining var and consts to be re-used in this project
export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/'; // using uppercase is a common practice for variables that will not change.
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '40a67d6e-744a-4550-982b-601b58f02b98';
export const MODAL_CLOSE_SEC = 2.5;
